import { render } from "./UtentiDataTable.vue?vue&type=template&id=d612ce28"
import script from "./UtentiDataTable.vue?vue&type=script&lang=js"
export * from "./UtentiDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__